module.exports = __webpack_public_path__ + "img/ctrl-fswap-stub-+.f85bf797.svg";